var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#333191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4661 20.643C16.025 19.5649 15.0908 17.8451 15.0908 15.9087C15.0908 12.648 17.7397 10 21.0004 10C24.2611 10 26.9091 12.648 26.9091 15.9087C26.9091 19.1694 24.2611 21.8183 21.0004 21.8183C16.4852 21.8183 12.8187 25.4839 12.8187 30H11C11 25.7242 13.6888 22.0723 17.4661 20.643ZM26.0074 24.0837H22.8327V25.9015H26.0074V29.0763H27.8253V25.9015H31V24.0837H27.8253V20.9089H26.0074V24.0837ZM21.0004 19.9996C18.7418 19.9996 16.9096 18.1672 16.9096 15.9087C16.9096 13.651 18.7419 11.8179 21.0004 11.8179C23.2581 11.8179 25.0913 13.6511 25.0913 15.9087C25.0913 18.1673 23.2581 19.9996 21.0004 19.9996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserIcon);
export default __webpack_public_path__ + "static/media/addUserIcon.f8a19e536b8b7f2340edc36dadc4fb5d.svg";
export { ForwardRef as ReactComponent };